import i18next from 'i18next'

/**
 * Translates an error code to a user-friendly message.
 * Falls back to the original message if no translation is found.
 *
 * @param errorCode - The error code in dot notation (e.g., "account.user.alreadyExists")
 * @param fallbackMessage - The fallback message to use if translation is not found
 * @returns The translated error message
 */
export function translateError(
	errorCode?: string,
	fallbackMessage?: string
): string {
	if (!errorCode) {
		return fallbackMessage || 'An unexpected error occurred'
	}

	// errorCode format: "account.user.alreadyExists"
	// Translation key: "apiError:account.user.alreadyExists"
	const translationKey = errorCode

	const translated = i18next.t(`apiError:${translationKey}`, {
		defaultValue: fallbackMessage || errorCode,
	})

	return translated
}
